var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var OrganisationIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 57,
    glyphHeight: 65,
    glyphOffsetY: 8
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.1719 64.9244V61.1311H17.6804V63.7014C19.7814 64.2776 21.9501 64.6902 24.1719 64.9244ZM9.02502 60.2129V9.19884H47.9742V60.213C51.1354 58.493 54.0438 56.3673 56.6296 53.9058V0.543457H0.369629V53.9056C2.95547 56.3671 5.8639 58.4929 9.02502 60.2129ZM39.3189 63.7014V61.1311H32.8273V64.9244C35.0492 64.6902 37.2179 64.2777 39.3189 63.7014ZM17.6802 17.854H24.1718V24.3455H17.6802V17.854ZM39.3187 17.854H32.8271V24.3455H39.3187V17.854ZM17.6802 28.6732H24.1718V35.1648H17.6802V28.6732ZM39.3187 28.6732H32.8271V35.1648H39.3187V28.6732ZM17.6802 39.4925H24.1718V45.9841H17.6802V39.4925ZM39.3187 39.4925H32.8271V45.9841H39.3187V39.4925ZM17.6802 50.3118H24.1718V56.8033H17.6802V50.3118ZM39.3187 50.3118H32.8271V56.8033H39.3187V50.3118Z",
    fill: "black"
  }));
};
export var OrganisationIconGlyph = function (props) {
  return React.createElement(OrganisationIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};